export default "__VITE_ASSET__DpwSVGDl__"